import React, { useEffect, useState } from "react"
import { Container, Table, Row, Col, Card, CardBody, Form, Label, Modal } from "reactstrap"
import classNames from "classnames"
import "../../../assets/css/Work/developmentSection.css"
import { fetchNodeData, FetchNodePostData, FetchPostData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import Swal from "sweetalert2"
import { Tooltip } from "antd"
import CustomerDetail from "./CustomerDetail"
import CustomerContact from "./CustomerContact"
import ProjectNotes from "./ProjectNotes"
import ProjectCreation from "./ProjectCreation"
import { useNavigate, useParams } from "react-router-dom"
import OverviewOnboarding from "./OverviewOnboarding"
import configure from "configure"


const StepNavigationStep = ({ step, currentStep, onStepChange }) => {
    const classes = classNames({
        active: step.id === currentStep,
        complete: currentStep > step.id,
    });

    return (
        <li className={classes} onClick={() => {
            // if (currentStep >= step.id) {
            onStepChange(step.id)
            // }
        }}>
            <div className="step">
                <i className={step.icon_class}></i>
            </div>
            <div className="caption hidden-xs hidden-sm">
                <span className="fs-5">{step.title}</span>
            </div>
        </li>
    );
};

const StepNavigation = ({ steps, currentStep, onStepChange }) => {
    return (
        <ol className="step-indicator mb-0">
            {steps.map(step => (
                <StepNavigationStep
                    key={step.id}
                    step={step}
                    currentStep={currentStep}
                    onStepChange={onStepChange}
                />
            ))}
        </ol>
    );
};



const ConvertCustomer = ({ projectDetails, toggleLoading }) => {
    const [currentStep, setCurrentStep] = useState(1)
    const [isLoading, setLoading] = useState(false)
    const [stageData, setStateData] = useState({})

    const params = useParams();
    const token = secureLocalStorage.getItem('auth_id')
    const steps = [
        { id: 1, title: "Customer Detail", icon_class: "bi bi-1-circle-fill" },
        { id: 2, title: "Customer Contact", icon_class: "bi bi-2-circle-fill" },
        { id: 3, title: "Project Creation", icon_class: "bi bi-3-circle-fill" },
        { id: 4, title: "Project Notes", icon_class: "bi bi-4-circle-fill" },
        { id: 5, title: "Overview", icon_class: "bi bi-5-circle-fill" },
    ]
    const stepChanged = step => {
        setCurrentStep(step)
    }
    const onCommonChange = async (stage) => {
        const formEntries = {
            id: params?.id,
            stage: stage,
        }
        const res = await FetchNodePostData(setLoading, 'stageProcess', token, formEntries);
    }
    const onSendRequest = async () => {
        const formEntires = {
            lead_id: stageData?.lead_id,
            status: 5
        }
        const res = await FetchNodePostData(setLoading, 'leadCOPstatus', token, formEntires);
        if (res?.data?.success) {
            Swal.fire({
                icon: 'success',
                text: "Process Completed successfully"
            }).then(() => {
                navigate(`${configure.appUrl}sales/lead`)
            })
        }
    }
    const navigate = useNavigate()
    const onChangingStep = (e) => {
        if (currentStep == 1) {
            if (stageData?.customer_id != null) {
                setCurrentStep(2)
                onCommonChange(2, 2)
            } else {
                Swal.fire({
                    icon: "warning",
                    text: "Please Save the Customer Details",
                })
            }
        } else if (currentStep == 2) {
            onCommonChange(3)
            setCurrentStep(3)
        } else if (currentStep == 3) {
            onCommonChange(4)
            setCurrentStep(4)
        } else if (currentStep == 4) {
            onCommonChange(5)
            setCurrentStep(5)
        } else if (currentStep == 5) {
            Swal.fire({
                icon: 'warning',
                title: "Are You sure?",
                text: "You want to Completed the onboarding Process?",
                showCancelButton: true,
                confirmButtonText: 'Yes, completed it!',
                cancelButtonText: 'No, cancel!',
            }).then((isOkay) => {
                if (isOkay?.isConfirmed) {
                    onSendRequest()
                }
            })
        }
    }

    const getFetchStep = async () => {
        const res = await fetchNodeData(setLoading, `stageProcess/${params?.id}`, token);
        if (res?.success) {
            setStateData(res?.data)
            setCurrentStep(res?.data?.stage || 1)
        }
    }

    useEffect(() => {
        getFetchStep()
    }, [])

    return (
        <React.Fragment>
            <div className="page-content mb-4">
                <Container fluid >
                    <Row>
                        <Col lg={12} className="p-0">
                            <Card>
                                <CardBody>
                                    <form action="">
                                        <div className='d-flex justify-content-between align-items-center wizard'>
                                            <h5 className='mb-0 fw-bold col-6 d-flex justify-content-start align-items-center gap-2 text-purple'>
                                                Customer Onboarding
                                            </h5>
                                            <div className='col-6 d-flex gap-2 justify-content-end align-items-center'>
                                                {currentStep != 5 ? (
                                                    <a className=" btn text-white text-uppercase me-0 btn-save btn-label border-radius"
                                                        onClick={(e) => onChangingStep(e)}>
                                                        <i className="fas fa-save  label-icon"></i>
                                                        Save & Next
                                                    </a>
                                                ) : (
                                                    <a className=" btn text-white text-uppercase me-0 btn-success border-radius" onClick={(e) => onChangingStep(e)}>
                                                        <i className="fas fa-save  label-icon me-2"></i>
                                                        Complete Process
                                                    </a>
                                                )}
                                            </div>
                                            {(projectDetails?.send_for_approve == 1 && (
                                                <Tooltip title={`Approved by Mohit Kapadnis`} color="#752B97">
                                                    <i
                                                        className="fas fa-check-circle text-success"
                                                        style={{
                                                            fontSize: "20px",
                                                            marginLeft: "8px",
                                                        }}
                                                    />
                                                </Tooltip>
                                            )
                                            )}
                                        </div>
                                        <div className="container-fluid">
                                            <StepNavigation steps={steps} currentStep={currentStep} onStepChange={stepChanged} />
                                        </div>
                                    </form>
                                </CardBody>
                            </Card>

                            {currentStep == 1 ? (
                                <>
                                    <CustomerDetail stageData={stageData} getFetchStep={getFetchStep} />
                                </>
                            ) : currentStep == 2 ? (
                                <>
                                    <CustomerContact stageData={stageData} />
                                </>
                            ) : currentStep == 3 ? (
                                <>
                                    <ProjectCreation stageData={stageData} getFetchStep={getFetchStep} />
                                </>
                            ) : currentStep == 4 ? (
                                <>
                                    <ProjectNotes stageData={stageData} />
                                </>
                            ) : currentStep == 5 ? (
                                <>
                                    <OverviewOnboarding stageData={stageData} />
                                </>
                            ) : null}

                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default ConvertCustomer